import styled from 'styled-components';
import { Lines360, PlayButton } from '../../../components/icons';
import Theme from '../../../Theme';

const PreviewImageContainer = styled.div`
  position: absolute;
  right: -7.5vw;
  top: 50%;
  transform: translate(-50%, -50%);
  
  width: 40vw;
  height: 40vw;

  @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    width: 230px;
    height: 230px;
    left: calc(50% - 50px);
    top: 200px;
  }

  @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
    left: calc(50% - 50px);
  }

  border-radius: 50%;
  overflow: hidden;

  z-index: 2;
  cursor: pointer;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  > svg {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
  }
`;

type Props = {
  src: string
  playVideo: () => void
}

const PreviewImage = ({ src, playVideo }: Props) => {
  return (
    <PreviewImageContainer>
      <img key={src} src={src} />
      <Lines360 />
      <div onClick={playVideo}>
        <PlayButton />
      </div>
    </PreviewImageContainer>
  );
};

export default PreviewImage;